var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRoundFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7109 14.9658C24.7109 20.7648 20.0099 25.4658 14.2109 25.4658C8.41195 25.4658 3.71094 20.7648 3.71094 14.9658C3.71094 9.16683 8.41195 4.46582 14.2109 4.46582C20.0099 4.46582 24.7109 9.16683 24.7109 14.9658ZM8.83716 20.3396C8.44664 19.9491 8.44664 19.3159 8.83716 18.9254L12.7967 14.9658L8.83716 11.0063C8.44664 10.6157 8.44664 9.98257 8.83716 9.59205C9.22769 9.20152 9.86085 9.20152 10.2514 9.59205L14.2109 13.5516L18.1705 9.59205C18.561 9.20152 19.1942 9.20152 19.5847 9.59205C19.9752 9.98257 19.9752 10.6157 19.5847 11.0063L15.6252 14.9658L19.5847 18.9254C19.9752 19.3159 19.9752 19.9491 19.5847 20.3396C19.1942 20.7301 18.561 20.7301 18.1705 20.3396L14.2109 16.38L10.2514 20.3396C9.86085 20.7301 9.22769 20.7301 8.83716 20.3396Z",
    fill: "#F32C05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRoundFill);
export default __webpack_public_path__ + "static/media/close_round_fill.e7307f68c5843ac9227c1d2039c9fb10.svg";
export { ForwardRef as ReactComponent };